import { Divider } from 'primereact/divider';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './InvoiceItem.module.scss';

export type ItemProps = {
  label: string;
  value: number;
  items?: ItemProps[];
};

type InvoiceItemListProps = {
  items: ItemProps[];
  total: number;
  hideTotal?: boolean;
};

const InvoiceItem: React.FC<ItemProps> = ({ label, value, items }) => (
  <>
    <div className={styles.items}>
      <span className={styles.label}>{label}</span>
      <span className={styles.price}>
        {value?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </div>
    {items?.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index} className={styles.subitem}>
        <span>{item.label}</span>
        <span>
          {item.value
            ? item.value?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : null}
        </span>
      </div>
    ))}
    <Divider className={`mb-0 ${styles.customDivider}`} />
  </>
);

const TotalInvoiceItem: React.FC<{ label: string; value: number }> = ({
  label,
  value,
}) => (
  <div className={styles.itemsTotal}>
    <span className={styles.labelTotal}>{label}</span>
    <span>
      <span className={styles.labelValueIcon}>U$S</span>
      <span className={styles.labelValue}>
        {value?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </span>
  </div>
);

const InvoiceItemList: React.FC<InvoiceItemListProps> = ({
  items,
  total,
  hideTotal = false,
}) => {
  const { t } = useTranslation('paymentInquiry');

  return (
    <div className={styles.invoiceItems}>
      {items?.map((item, index) => (
        <InvoiceItem
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          label={item.label}
          value={item.value}
          items={item.items}
        />
      ))}
      {items && !hideTotal && (
        <TotalInvoiceItem label={t('total')} value={total} />
      )}
    </div>
  );
};

export default InvoiceItemList;
